import { Component } from '@angular/core';

import { CustomListComponent } from '../custom-list/custom-list.component';

@Component({
  selector: 'app-custom-sales-claiming-list',
  templateUrl: './custom-sales-claiming-list.component.html',
  styleUrls: ['./custom-sales-claiming-list.component.scss'],
})
export class CustomSalesClaimingListComponent extends CustomListComponent {
  override itemsPerPageDisplayKey = `${this.translate.instant('Items per page')}:`;
  override entriesDisplayKey = '';
}
